var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import IconLoading from '../../icon/react-icon/IconLoading';
import Group from './group';
import cs from '../_util/classNames';
import { ConfigConsumer } from '../ConfigProvider';
var buttonTypes = ['default', 'primary', 'dashed', 'warning', 'danger', 'text'];
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (event) {
            var _a = _this.props, loading = _a.loading, onClick = _a.onClick;
            !loading && onClick && onClick(event);
        };
        _this.renderBtn = function (_a) {
            var _b;
            var getPrefixCls = _a.getPrefixCls, ctxSize = _a.size;
            var _c = _this.props, className = _c.className, type = _c.type, style = _c.style, disabled = _c.disabled, children = _c.children, size = _c.size, loading = _c.loading, href = _c.href, shape = _c.shape, iconOnly = _c.iconOnly, htmlType = _c.htmlType, loadingFixedWidth = _c.loadingFixedWidth, ghost = _c.ghost, rest = __rest(_c, ["className", "type", "style", "disabled", "children", "size", "loading", "href", "shape", "iconOnly", "htmlType", "loadingFixedWidth", "ghost"]);
            var prefixCls = getPrefixCls('btn');
            var classNames = cs(prefixCls, prefixCls + "-" + type, prefixCls + "-size-" + (size || ctxSize), prefixCls + "-shape-" + shape, (_b = {},
                _b[prefixCls + "-loading-fixed-width"] = loadingFixedWidth,
                _b[prefixCls + "-loading"] = loading,
                _b[prefixCls + "-link"] = href,
                _b[prefixCls + "-icon-only"] = (loading && !children) || iconOnly,
                _b[prefixCls + "-disabled"] = disabled,
                _b[prefixCls + "-background-ghost"] = ghost,
                _b), className);
            var mapedChildren = React.Children.map(children, function (child) {
                return typeof child === 'string' ? React.createElement("span", null, child) : child;
            });
            if (href) {
                var hrefProps = {};
                if (!disabled) {
                    hrefProps.href = href;
                }
                return (React.createElement("a", __assign({}, rest, hrefProps, { className: classNames, onClick: _this.handleClick, style: style }),
                    loading ? (React.createElement("span", { className: prefixCls + "-loading-wrapper" },
                        React.createElement(IconLoading, null))) : null,
                    mapedChildren));
            }
            return (React.createElement("button", __assign({}, rest, { disabled: disabled, className: classNames, onClick: _this.handleClick, style: style, type: htmlType }),
                loading ? (React.createElement("span", { className: prefixCls + "-loading-wrapper" },
                    React.createElement(IconLoading, null))) : null,
                mapedChildren));
        };
        return _this;
    }
    Button.prototype.render = function () {
        return React.createElement(ConfigConsumer, null, this.renderBtn);
    };
    Button.displayName = 'Button';
    Button.Group = Group;
    Button.propTypes = {
        children: PropTypes.any,
        className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        style: PropTypes.object,
        disabled: PropTypes.bool,
        onClick: PropTypes.func,
        size: PropTypes.oneOf(['small', 'default', 'large', 'huge']),
        type: PropTypes.oneOf(buttonTypes),
        htmlType: PropTypes.oneOf(['submit', 'button', 'reset']),
        loading: PropTypes.bool,
        href: PropTypes.string,
        target: PropTypes.string,
        shape: PropTypes.oneOf(['circle', 'round', 'square']),
        iconOnly: PropTypes.bool,
        loadingFixedWidth: PropTypes.bool,
        ghost: PropTypes.bool,
    };
    Button.defaultProps = {
        children: '',
        className: '',
        disabled: false,
        onClick: function () { },
        style: {},
        type: 'default',
        loading: false,
        shape: 'square',
        htmlType: 'button',
    };
    Button.__BYTE_BUTTON = true;
    return Button;
}(PureComponent));
export default Button;
